import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AnalysisApiClientAccess, AppRoleService, checkIdentityRole } from '@nk/access-block';
import { CachingService } from '@nk/caching-lib';
import {
  AppFeatureKey,
  AppRoleDims,
  AppRoleKey,
  MonitoringConnectionCompositeEntity,
  MonitoringConnectionHistoryCompositeEntity,
  SimpleCollection,
} from '@nk/data-entities-lib';
import { Observable, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MonitoringConnectionService {
  constructor(
    private _analysisApiAccess: AnalysisApiClientAccess,
    private _cachingService: CachingService,
    private _appRoleService: AppRoleService,
  ) {}

  public checkIdentityRole(): Observable<AppRoleDims> {
    return this._appRoleService.activeAppRoleDimsCache.get().pipe(checkIdentityRole([AppRoleKey.aml]));
  }

  public monitoringConnectionCompositeCollectionCache = this._cachingService.create(
    this,
    this.fetchMonitoringConnectionCompositeCollection,
  );
  public fetchMonitoringConnectionCompositeCollection(
    screeningConfigUuid: string,
    monitoringOriginEntityUuid: string | undefined,
    screeningEntityUuid: string | undefined,
    limit: number,
    offset: number,
  ): Observable<SimpleCollection<MonitoringConnectionCompositeEntity>> {
    let params = new HttpParams();
    if (monitoringOriginEntityUuid) {
      params = params.append('monitoring_origin_entity_uuid', monitoringOriginEntityUuid);
    }
    if (screeningEntityUuid) {
      params = params.append('screening_entity_uuid', screeningEntityUuid);
    }
    params = params.append('limit', limit);
    params = params.append('offset', offset);
    return this.checkIdentityRole().pipe(
      switchMap(() => {
        return this._analysisApiAccess.get<SimpleCollection<MonitoringConnectionCompositeEntity>>(
          `/screening-config/${screeningConfigUuid}/monitoring-connection-composite-collection`,
          { params },
          [AppFeatureKey.base, AppFeatureKey.screening],
          [AppRoleKey.aml],
        );
      }),
    );
  }

  public monitoringConnectionHistoryCompositeCollectionCache = this._cachingService.create(
    this,
    this.fetchMonitoringConnectionHistoryCompositeCollection,
  );
  public fetchMonitoringConnectionHistoryCompositeCollection(
    screeningConfigUuid: string,
    monitoringOriginEntityUuid: string | undefined,
    screeningEntityUuid: string | undefined,
    limit: number,
    offset: number,
  ): Observable<SimpleCollection<MonitoringConnectionHistoryCompositeEntity>> {
    let params = new HttpParams();
    if (monitoringOriginEntityUuid) {
      params = params.append('monitoring_origin_entity_uuid', monitoringOriginEntityUuid);
    }
    if (screeningEntityUuid) {
      params = params.append('screening_entity_uuid', screeningEntityUuid);
    }
    params = params.append('limit', limit);
    params = params.append('offset', offset);
    return this.checkIdentityRole().pipe(
      switchMap(() => {
        return this._analysisApiAccess.get<SimpleCollection<MonitoringConnectionHistoryCompositeEntity>>(
          `/screening-config/${screeningConfigUuid}/monitoring-connection-history-composite-collection`,
          { params },
          [AppFeatureKey.base, AppFeatureKey.screening],
          [AppRoleKey.aml],
        );
      }),
    );
  }
}
